/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2023-04-04 16:43:39
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\specialmaterial\prodplan.js
 */
/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-05-31 15:22:33
 */
export const queryPage = '/icps/system/sign/intelligent/materials/plan/production/queryPage'
export const saveOrUpdate = '/icps/system/sign/intelligent/materials/plan/production/save'
export const Download = '/icps/system/sign/intelligent/materials/plan/production/exportProductPlan'
import request from '@/utils/request'
//入库/确认完工
export function updateDataStatus(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/plan/production/updateDataStatus',
    method: 'post',
    data
  })
}
//入库  新
export function planWarehousing(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/plan/production/planWarehousing',
    method: 'post',
    data
  })
}
//特材原料/成品，分页查询
export function productList(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/product/queryPage',
    method: 'post',
    data
  })
}
//分页查询特材罐
export function tankList(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/queryPage',
    method: 'post',
    data
  })
}
/**通过特材成品名称获取废料罐*/
export function getWasteListByProductId(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/getWasteListByProductId',
    method: 'get',
    params
  })
}
/**通过公司获取废料罐*/
export function getSpecialTankList(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/getSpecialTankList',
    method: 'get',
    params
  })
}
/**修改*/
export function updatePlan(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/plan/production/updatePlan',
    method: 'post',
    data
  })
}
/**冲销*/
export function planBack(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/plan/production/planBack',
    method: 'post',
    data
  })
}


